import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@mantine/core'
import { FacadeSystem } from '@/features/facade/FacadeSystem/types'
import useStyles from './TopBar.styles'

interface IProps {
  data: FacadeSystem
}

export const TopBar = ({ data }: IProps) => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  const { name, article } = data

  return (
    <Box className={classes.root}>
      <Text title={name} truncate weight={600}>
        {name} - {article}
      </Text>
    </Box>
  )
}
